import React, { Component } from 'react';
import '../App.css';
import bg from './bg-results.svg';

class DefaultResult extends Component {
  render() {
    return (
      <div className='default'>
        <h2 className='left-align'>
          PUBLIC OPINION SURVEY ON COVID-19 IMPACT IN ODISHA
        </h2>
        <hr className='left-align' />
        <p className='left-align'>
          During this unplanned “forced” hiatus locked at home, we have had the
          opportunity to be closer - both in the real and virtual worlds - to
          our family, friends, and also to ourselves. Some might be frustrated
          with the restrictions imposed, while some seized the opportunity to
          start “doing” things that they always wished to but never had the
          time. With the uncertainty looming, what is in store for us every
          minute, hour, next day, next week, next fortnight or next month – all
          these time metrics seem to be critical, yet unpredictable and beyond
          our control.{' '}
        </p>
        <p className='left-align'>
          <strong>
            While Odisha has been relatively successful in controlling the
            spread of this deadly virus in the first phase of lockdown, it is
            hard to ignore what impact COVID-19 has and will have on our lives.
          </strong>
          On one hand, the future economic impacts seem inevitable and daunting,
          on the other hand, answers related to changes in our social
          interactions and habits are more ambiguous.
        </p>
        <p className='left-align'>
          <strong>
            Quantum Leap Studio (QLS), a Bhubaneswar-based applied research
            start-up launched a data collection crowdsourced initiative to
            collect public opinions on the real and perceived impact of
            COVID-19. The survey comprised of a series of questions, which
            supported multiple answers for some questions.
          </strong>
        </p>
        <hr className='left-align' />
        <p className='left-align'>
          <strong>
            Sourced, Surveyed & Published by - Quantum Leap Studio
          </strong>
        </p>
        <p className='left-align'>
          <strong>Region - Odisha</strong>
        </p>
        <p className='left-align'>
          <strong>Method of interview - Online survey</strong>
        </p>
        <div className='bg-container'>
          <img src={bg} alt='survey background' className='bg' />
        </div>
      </div>
    );
  }
}

export default DefaultResult;
